import "./Membership.module.css";
import ClinicHeader from "@/reusable_sections/Header";
import TheBurnFluxAdvantage from "./sections/TheBurnFluxAdvantage";
import InvestmentAndPackages from "./sections/InvestmentAndPackages";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function MembershipPage() {
  return <div>
      <ClinicHeader />
      <TheBurnFluxAdvantage />
      <InvestmentAndPackages />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}